<template>
  <div class="container">
    <div class="contentContainer">
      <p>{{ title }}</p>
      <div class="phone infoContainer">
        <input
          type="number"
          placeholder="请输入手机号码"
          v-model="phoneNumber"
        />
        <div>
          <span @click="onGetYanzhengma">{{ msg }}</span>
        </div>
      </div>

      <div v-if="false" class="wxCode infoContainer">
        <input type="" placeholder="请输入微信号码" v-model="umemo" />
        <div>
          <span>微信号码</span>
        </div>
      </div>

      <div class="userName infoContainer">
        <input type="" placeholder="请输入姓名" v-model="realName" />
        <div>
          <span>姓名</span>
        </div>
      </div>

      <div class="yanzhengma" v-show="phoneAboutShow">
        <input type="number" placeholder="请输入验证码" v-model="yanzhengma" />
      </div>
      <div class="btnFooter" @click="onCheckReport">继续</div>
      <div class="yinsi">
        <img @click="onSelect" :src="iconUrl" alt="" />
        <span
          >我已阅读并同意<span
            @click="showPopup"
            style="color: #297bff; text-decoration: underline"
            >《隐私协议》</span
          ></span
        >
      </div>
      <van-popup
        v-model="isShow"
        round
        position="bottom"
        :style="{ height: '70%' }"
      >
        <span class="xieyiTitle">隐私协议</span>
        <div class="xieyiContainer">
          <span
            >科飞智能评估隐私保护指引<br />本指引是科飞智能评估开发者
            "合肥科飞视觉科技有限公司"（以下简称“开发者”）为处理你的个人信息而制定。<br />开发者处理的信息<br />根据法律规定，开发者仅处理实现小程序功能所必要的信息。<br />为了验证登录信息，开发者将在获取你的明示同意后，收集你的个人信息。<br />为了显示位置信息，开发者将在获取你的明示同意后，收集你的位置信息。<br />为了保存和读取视频和照片，开发者将在获取你的明示同意后，使用你的相册（仅写入）权限。<br />你的权益<br />关于你的个人信息，你可以通过以下方式与开发者联系，行使查阅、复制、更正、删除等法定权利。<br />电话:0551-68562028<br />开发者对信息的存储<br />开发者承诺，除法律法规另有规定外，开发者对你的信息的保存期限应当为实现处理目的所必要的最短时间。<br />信息的使用规则<br />开发者将会在本指引所明示的用途内使用收集的信息
            如开发者使用你的信息超出本指引目的或合理范围，开发者必须在变更使用目的或范围前，再次以短信方式告知并征得你的明示同意。<br />信息对外提供<br />开发者承诺，不会主动共享或转让你的信息至任何第三方，如存在确需共享或转让时，开发者应当直接征得或确认第三方征得你的单独同意。<br />开发者承诺，不会对外公开披露你的信息，如必须公开披露时，开发者应当向你告知公开披露的目的、披露信息的类型及可能涉及的信息，并征得你的单独同意。<br />你认为开发者未遵守上述约定，或有其他的投诉建议、或未成年人个人信息保护相关问题，可通过以下方式与开发者联系；或者进行投诉。<br />电话
            : 0551-68562028<br />更新日期：2021-12-08<br />生效日期：2021-12-08</span
          >
        </div>
        <div @click="onDisagree" class="xieyiDisagree">不同意</div>
        <div @click="onAgree" class="xieyiAgree">同意</div>
      </van-popup>
    </div>
    <div id="imgContainer" v-if="isTipShow">
      <img id="showImg" src="../../assets/common/tip.png" alt="" />
      <p>您准备好了吗，让我们开始吧！</p>
      <div class="btnNext" @click="onNext">下一步</div>
    </div>
    <!-- <iframe
      v-show="!isAnwser"
      src="https://api00.uflycloud.com/zjtest/wenjuan/"
      frameborder="0"
      scrolling="no"
    ></iframe> -->
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  name: "Phone",
  data() {
    return {
      isTipShow: false,
      title: "",
      iconUrl: "",
      msg: "获取验证码",
      phoneNumber: "",
      yanzhengma: "",
      isShow: false,
      phoneAboutShow: false,
      realName: "",
      umemo: "",
      isAnwser: true,
    };
  },
  watch: {
    isAnwser(n) {
      console.log(!n);
      if (!n) {
        this.$router.push("/form");
      }
    },
  },
  methods: {
    onDisagree() {
      this.iconUrl = require("../../assets/common/select.png");
      this.isShow = false;
    },
    onAgree() {
      this.iconUrl = require("../../assets/common/selected.png");
      this.isShow = false;
    },
    showPopup() {
      this.isShow = true;
    },
    onCheckReport() {
      //判断是否是手机号码
      // if(!this.isPoneAvailable(this.phoneNumber)&&this.$store.state.global.phone===''){
      //     this.$dialog.alert({
      //         message:'请输入正确的手机号码',
      //     })
      //     return
      // }
      // if(this.umemo===''&&this.$store.state.global.umemo===''){
      //     this.$dialog.alert({
      //         message:'请输入微信号码',
      //     })
      //     return
      // }
      if (this.realName === "" && this.$store.state.global.realName === "") {
        this.$dialog.alert({
          message: "请输入姓名",
        });
        return;
      }
      if (this.yanzhengma === "" && this.$store.state.global.phone === "") {
        this.$dialog.alert({
          message: "请输入验证码",
        });
        return;
      }
      if (this.iconUrl === require("../../assets/common/select.png")) {
        this.$dialog.alert({
          message: "请阅读并同意《隐私协议》",
        });
        return;
      }
      if (this.$store.state.global.isLoadingShow) {
        return;
      }
      this.$store.state.global.isLoadingShow = true;
      if (this.$store.state.global.phone === "") {
        this.$axios({
          url: this.$store.state.global.url + "/v5/token/validPhoneCode",
          method: "post",
          data: {
            phone: this.phoneNumber,
            code: this.yanzhengma,
            realName: this.realName,
            umemo: this.umemo,
          },
          headers: {
            Authorization: "Bearer " + this.$store.state.global.token,
            serverFlag: "",
            dsName: "",
          },
        }).then(
          (response) => {
            this.$store.state.global.isLoadingShow = false;
            if (!response.data.success) {
              this.$dialog.alert({
                message: response.data.message + "!",
              });
            } else {
              //跳转冯超
              // wx.miniProgram.redirectTo({
              //     url: '/pages/detail/report/report?scene='+this.$store.state.global.globalId
              // })
              // this.isTipShow=true
              this.isAnwser = false;
            }
          },
          (error) => {
            this.$store.state.global.isLoadingShow = false;
            this.$dialog.alert({
              message: "验证码验证失败，请稍后重试！",
            });
          }
        );
      } else {
        this.$store.state.global.isLoadingShow = false;
        //跳转冯超
        // wx.miniProgram.redirectTo({
        //     url: '/pages/detail/report/report?scene='+this.$store.state.global.globalId
        // })
        // this.isTipShow=true
        this.isAnwser = false;
      }
    },
    onSelect() {
      if (this.iconUrl === require("../../assets/common/select.png")) {
        this.iconUrl = require("../../assets/common/selected.png");
      } else {
        this.iconUrl = require("../../assets/common/select.png");
      }
    },
    onGetYanzhengma() {
      //判断是否是手机号码
      // if(!this.isPoneAvailable(this.phoneNumber)){
      //     this.$dialog.alert({
      //         message:'请输入正确的手机号码',
      //     })
      //     return
      // }
      if (this.msg === "获取验证码") {
        if (this.$store.state.global.isLoadingShow) {
          return;
        }
        this.$store.state.global.isLoadingShow = true;

        this.msg = "60";
        let timer = setInterval(() => {
          if (this.msg == "0") {
            clearInterval(timer);
            this.msg = "获取验证码";
            return;
          }
          this.msg = (parseInt(this.msg) - 1).toString();
        }, 1000);

        this.$axios({
          url: this.$store.state.global.url + "/v5/token/sendRegisterCode",
          method: "post",
          data: {
            phone: this.phoneNumber,
          },
          headers: {
            Authorization: "Bearer " + this.$store.state.global.token,
            serverFlag: "",
            dsName: "",
          },
        }).then(
          (response) => {
            this.$store.state.global.isLoadingShow = false;
            this.$dialog.alert({
              message: "验证码获取成功！",
            });
          },
          (error) => {
            this.$store.state.global.isLoadingShow = false;
            this.$dialog.alert({
              message: "验证码获取失败，请稍后重试！",
            });
          }
        );
      }
    },
    onNext() {
      if (this.$store.state.global.isFirst) {
        this.$store.state.global.itemNum = 1;
      } else {
        this.$store.state.global.itemNum = 0;
      }

      this.isTipShow = false;

      if (this.$store.state.global.personalInformationBol) {
        this.$router.push("/commonDescription");
      } else {
        this.$router.push("/personalInformation");
      }
    },
    isPoneAvailable(str) {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!myreg.test(str)) {
        return false;
      } else {
        return true;
      }
    },
    sendWenJuan() {
      this.$axios({
        url:
          this.$store.state.global.padUrl +
          "/visualplatpad/detector-report/save",
        method: "post",
        data: {
          globalId: this.$store.state.global.globalId,
          testType: 99,
          testResult: JSON.stringify({
            data: this.$store.state.global.wenJuan,
          }),
        },
        headers: {
          Authorization: "Bearer " + this.$store.state.global.token,
          serverFlag: "",
          dsName: "",
          "content-type": "application/json",
        },
      });
    },
  },
  mounted() {
    this.$store.state.global.wenJuan = null;
    this.$store.state.global.isTrans = false;
    this.iconUrl = require("../../assets/common/select.png");
    if (this.$store.state.global.phone === "") {
      this.title = "请留下您的联系方式";
      this.phoneAboutShow = true;
    } else {
      this.phoneNumber = this.$store.state.global.phone;
      // this.umemo=this.$store.state.global.umemo
      this.realName = this.$store.state.global.realName;
      this.title = "您的联系方式";
      this.phoneAboutShow = false;
      this.msg = "手机号码";
    }
    if (this.phoneNumber != "" && this.realName != "") {
      this.onAgree();
    }
    const that = this;
    window.addEventListener("message", function (e) {
      if (e.data.basicInfo) {
        that.isAnwser = true;
        that.isTipShow = true;
        that.$store.state.global.wenJuan = e.data;
        that.sendWenJuan();
      }
    });
  },
};
</script>

<style scoped>
#imgContainer p {
  position: absolute;
  left: 50%;
  top: 85%;
  transform: translate(-50%, 0%);
  font-size: 3vw;
  white-space: nowrap;
}
#imgContainer {
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  position: relative;
}

iframe {
  position: absolute;
  width: 100%;
  height: 100%;
}
#showImg {
  position: absolute;
  width: 100%;
}
.btnNext {
  background: rgb(1, 220, 195);
  color: rgb(255, 255, 255);
  position: absolute;
  width: 30vw;
  border-radius: 2vw;
  height: 10vw;
  text-align: center;
  line-height: 10vw;
  font-size: 4vw;
  left: 35vw;
  top: 90%;
}
.container {
  background: rgb(237, 241, 248);
}
.contentContainer {
  position: absolute;
  top: 10%;
  left: 3vw;
  width: 94vw;
  height: 90%;
  background: white;
  border-radius: 3vw;
}
p {
  position: absolute;
  left: 50%;
  top: 10%;
  transform: translate(-50%, 0%);
  font-size: 7vw;
  white-space: nowrap;
}
input {
  border: none;
  border-bottom: 1px solid rgb(165, 165, 165);
  width: 70vw;
  height: 10vw;
  font-size: 4vw;
  padding-left: 10vw;
}
.phone {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0%);
}
.wxCode {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, 0%);
}
.userName {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, 0%);
}
.infoContainer div {
  position: absolute;
  right: 20%;
  top: 50%;
  transform: translate(0%, -50%);
}
.infoContainer span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 3vw;
  white-space: nowrap;
}
.yanzhengma {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 0%);
}
.btnFooter {
  position: absolute;
  left: 50%;
  top: 80%;
  transform: translate(-50%, 0%);

  width: 80vw;
  height: 11vw;
  border-radius: 5vw;
  text-align: center;
  line-height: 11vw;
  font-size: 4vw;
  background: rgb(41, 123, 255);
  color: white;
}
.yinsi {
  position: absolute;
  left: 50%;
  top: 92%;
  transform: translate(-50%, 0%);
  display: flex;
  flex-direction: row;
}
.yinsi img {
  width: 5vw;
  margin-right: 2vw;
}
.yinsi span {
  white-space: nowrap;
  padding-top: 0.5vw;
  line-height: 4.5vw;
  font-size: 4vw;
  color: rgb(153, 153, 153);
}
.xieyiTitle {
  color: #000000;
  position: absolute;
  font-size: 6vw;
  left: 50%;
  top: 10%;
  transform: translate(-50%, 0%);
}
.xieyiContainer {
  width: 90%;
  height: 65%;
  position: absolute;
  left: 50%;
  top: 20%;
  transform: translate(-50%, 0%);
  overflow: auto;
}
.xieyiContainer span {
  word-break: normal;
  width: auto;
  display: block;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: hidden;
  font-size: 4vw;
  line-height: 6vw;
}
.xieyiDisagree {
  width: 35vw;
  height: 10vw;
  background: rgb(240, 240, 240);
  border-radius: 5vw;
  line-height: 10vw;
  text-align: center;
  position: absolute;
  left: 10%;
  top: 90%;
}
.xieyiAgree {
  width: 35vw;
  height: 10vw;
  background: rgb(41, 123, 255);
  border-radius: 5vw;
  line-height: 10vw;
  text-align: center;
  position: absolute;
  right: 10%;
  top: 90%;
}
</style>
